<div class="row">
  <div class="col-lg-2" style="background-color: #F2F2F2">
    <app-admin-menu></app-admin-menu>
  </div>
  <div class="col-lg-10" style="padding-top: 54px;">
    <div class="admin-main-container-content">
      <div class="header-title-admin">{{'' | i18n: 'e4n-upload-title'}}</div>
      <form [formGroup]="uploadForm">
        <div class="container-header-bar" style="padding-top: 8px;">{{'' | i18n: 'latest-Sale-Date'}}: {{latestDate}}</div>
        <br>
          <div class="form-label-sm">{{'' | i18n: 'upload-E4n-CSV-Files'}}</div>
          <div class="row-container">
            <input style="height: 38px;" formControlName="document" type="file" ng2FileSelect accept=".csv" [uploader]="uploader" multiple/>
          </div>
          @for (item of uploader.queue; track item) {
            <div class="container-sub-header-bar" style="padding-top: 8px;">
              <div class="files-names">{{'' | i18n: 'file-name'}}</div>
              <div class="files-remove">{{'' | i18n: 'remove'}}</div>
            </div>
          }
        </form>
        @for (item of uploader.queue; track item) {
          <div class="row-container">
            <div class="files-names">{{ item._file.name }}</div>
            <div class="files-remove"><button (click)="item.remove()" class="button button-edit">
              <img src="assets/images/icon-remove.png" width="20px" height="20px" class="table-icon">
            </button></div>
          </div>
        }
        <div class = "row mt-3">
          <button (click)="uploade4nFiles()">{{'' | i18n: 'upload-files'}}</button>
        </div>

      </div>
    </div>
  </div>
